import { Icon } from '@chakra-ui/react';

export default function PlusIcon(props) {
  return (
    <Icon
      width={6}
      height={6}
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
      verticalAlign='center'
    >
      <path d='M12 20.3281C7.64844 20.3281 4.03125 16.7109 4.03125 12.3594C4.03125 8 7.64062 4.39062 11.9922 4.39062C16.3516 4.39062 19.9688 8 19.9688 12.3594C19.9688 16.7109 16.3594 20.3281 12 20.3281ZM12 19C15.6875 19 18.6406 16.0469 18.6406 12.3594C18.6406 8.67188 15.6797 5.71875 11.9922 5.71875C8.30469 5.71875 5.36719 8.67188 5.36719 12.3594C5.36719 16.0469 8.3125 19 12 19ZM8.375 12.3594C8.375 11.9688 8.64062 11.6953 9.03906 11.6953H11.3359V9.39844C11.3359 9 11.6016 8.72656 11.9844 8.72656C12.375 8.72656 12.6484 9 12.6484 9.39844V11.6953H14.9531C15.3438 11.6953 15.6172 11.9688 15.6172 12.3594C15.6172 12.7422 15.3438 13 14.9531 13H12.6484V15.3047C12.6484 15.7031 12.375 15.9688 11.9844 15.9688C11.6016 15.9688 11.3359 15.6953 11.3359 15.3047V13H9.03906C8.64062 13 8.375 12.7422 8.375 12.3594Z' />
    </Icon>
  );
}
